import React, { useState, useEffect } from "react";

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import customToasts from "../../../assets/reusableComponents/myToasts";

//functions for datat fetching
import {
  addProperty,
  caretaker,
  getAllProperties,
} from "../../../../redux/slices/sliceActions";
import { useSelector, useDispatch } from "react-redux";

//tour utilities
import {
  advanceTour,
  isInTourMode,
  getCurrentTourStep,
} from "../../../../utils/tourUtils";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

const CreatePropertyModal = ({ setShowModal }) => {
  //redux methods
  const dispatch = useDispatch();

  //property variables
  const [propertyName, setPropertyName] = useState("");
  const [propertyLocation, setPropertyLocation] = useState("");
  const [imagePreview1, setImagePreview1] = useState(null);
  const [imagePreview2, setImagePreview2] = useState(null);
  const [imagePreview3, setImagePreview3] = useState(null);
  const [imageFile1, setImageFile1] = useState(null);
  const [imageFile2, setImageFile2] = useState(null);
  const [imageFile3, setImageFile3] = useState(null);

  //navigation variables
  const [isCancelButtonHovered, setIsCancelButtonHovered] = useState(false);
  const [isNextButtonHovered, setIsNextButtonHovered] = useState(false);
  const [isSkipButtonClicked, setIsSkipButtonClicked] = useState(false);

  const [currentStep, setCurrentStep] = useState(1);
  const [isStep1Completed, setIsStep1Completed] = useState(false);
  const [isStep2Completed, setIsStep2Completed] = useState(false);
  const [isStep3Completed, setIsStep3Completed] = useState(false);

  const [translationValue, setTranslationValue] = useState(0);
  useEffect(() => {
    if (currentStep === 1) {
      setTranslationValue(0);
    }
    // if (currentStep === 2) {
    //   setTranslationValue(-500);
    // }
    if (currentStep === 3) {
      setTranslationValue(-500);
    }
    if (currentStep === 4) {
      setTranslationValue(-1000);
    }
  }, [currentStep]);

  const [showSkipButton, setShowSkipButton] = useState(false);
  const [showBackButton, setShowBackButton] = useState(false);

  const [isBackButtonHovered, setIsBackButtonHovered] = useState(false);

  //role variables
  const choices = ["Caretaker", "Admin", "WatchMan"];
  const [selectedRole, setSelectedRole] = useState(choices[0]);
  const [roleTakersName, setRoleTakersName] = useState("");
  const [roleTakerEmail, setRoleTakerEmail] = useState("");
  const [roleTakerPhoneNumber, setRoleTakerPhoneNumber] = useState("");

  //apartment charges variables
  const waterChargeTypeChoices = [
    "No charge",
    "Fixed amount",
    "Read from meter",
  ];

  const [rentDueDateChoices, setRentDueDateChoices] = useState([
    "1st",
    "5th",
    "10th",
    "15th",
    "20th",
    "25th",
    "30th",
  ]);
  const [selectedRentDueDate, setSelectedRentDueDate] = useState(
    rentDueDateChoices[0]
  );
  const lateFeeChargeTypeChoices = ["No charge", "Fixed amount", "% of Rent"];
  const [selectedWaterChargeType, setSelectedWaterChargeType] = useState(
    waterChargeTypeChoices[0]
  );
  const [selectedLateFeeChargeType, setSelectedLateFeeChargeType] = useState(
    lateFeeChargeTypeChoices[0]
  );
  const [selectedServiceFeeChargeType, setSelectedServiceFeeChargeType] =
    useState(lateFeeChargeTypeChoices[0]);
  const [selectedManagementFeeChargeType, setSelectedManagementFeeChargeType] =
    useState(lateFeeChargeTypeChoices[0]);
  const [waterCharge, setWaterCharge] = useState("0");
  const [lateFeeCharge, setLateFeeCharge] = useState("0");
  const [serviceFeeCharge, setServiceFeeCharge] = useState("0");
  const [managementFeeCharge, setManagementFeeCharge] = useState("0");
  const [garbageCharge, setGarbageCharge] = useState("0");

  //payment details variables
  const [mpesaPaymentMethodChoices, setMpesaPaymentMethodChoices] = useState([
    "Mpesa PayBill",
    "Mpesa Till Number",
  ]);
  const [selectedMpesaPaymentMethod, setSelectedMpesaPaymentMethod] = useState(
    mpesaPaymentMethodChoices[0]
  );
  const [paybillNumber, setPaybillNumber] = useState("");
  const [tillNumber, setTillNumber] = useState("");

  const [bankName, setBankName] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [mpesaAccountNumber, setMpesaAccountNumber] = useState("");

  //useeffect to check for any changes in role variables
  useEffect(() => {
    if (currentStep === 2) {
      //if roletaker name or email or phone number is empty then show skip button
      if (
        (roleTakersName.trim() === "" &&
          !roleTakerEmail.trim() === "" &&
          !roleTakerPhoneNumber.trim() === "") ||
        (roleTakerEmail.trim() === "" &&
          !roleTakersName.trim() === "" &&
          !roleTakerPhoneNumber.trim() === "") ||
        (roleTakerPhoneNumber.trim() === "" &&
          !roleTakersName.trim() === "" &&
          !roleTakerEmail.trim() === "") ||
        (roleTakersName.trim() === "" &&
          roleTakerEmail.trim() === "" &&
          roleTakerPhoneNumber.trim() === "")
      ) {
        setShowSkipButton(true);
      } else {
        setShowSkipButton(false);
        setIsNextButtonHovered(false);
      }
    }
  }, [roleTakersName, roleTakerEmail, roleTakerPhoneNumber]);

  //methods
  const closeModal = () => {
    setShowModal(false);
  };

  const handleImageChange1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview1(reader.result);
      };
      reader.readAsDataURL(file);
      setImageFile1(file);
    }
  };

  const handleImageChange2 = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview2(reader.result);
      };
      reader.readAsDataURL(file);
      setImageFile2(file);
    }
  };

  const handleImageChange3 = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview3(reader.result);
      };
      reader.readAsDataURL(file);
      setImageFile3(file);
    }
  };

  const [isNextButtonLoading, setIsNextButtonLoading] = useState(false);

  const setNextStep = () => {
    if (currentStep === 1) {
      if (
        propertyName === "" ||
        propertyLocation === "" ||
        !imageFile1 ||
        !imageFile2 ||
        !imageFile3
      ) {
        customToasts.error("Please fill all fields");
        return;
      }

      setIsStep1Completed(true);
      setCurrentStep(3);
      setShowSkipButton(true);
      setShowBackButton(true);
    }
    else if (currentStep === 3) {
      setIsStep3Completed(true);
      setCurrentStep(4);
    } else if (currentStep === 4) {
      // Validate all required fields in step 4
      if (
        (selectedMpesaPaymentMethod === "Mpesa PayBill" &&
          (paybillNumber.trim() === "" || mpesaAccountNumber.trim() === "")) ||
        (selectedMpesaPaymentMethod === "Mpesa Till Number" &&
          tillNumber.trim() === "")
        // ||
        // bankName.trim() === "" ||
        // bankAccountNumber.trim() === ""
      ) {
        customToasts.error("Please fill all payment details");
        return;
      }


      setIsNextButtonLoading(true);
      createProperty();
    }
  };

  //previous step
  const setPreviousStep = () => {
    setIsSkipButtonClicked(false);
    setIsCancelButtonHovered(false);
    setIsBackButtonHovered(false);
    if (currentStep === 1) {
      return;
    }
    // else if (currentStep === 2) {
    //   setShowBackButton(false);
    //   setCurrentStep(1);
    //   setIsStep1Completed(false);
    // }
    else if (currentStep === 3) {
      setCurrentStep(1);
      setIsStep2Completed(false);
    } else if (currentStep === 4) {
      setCurrentStep(3);
      setIsStep3Completed(false);
    }
  };

  //styles
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.7)", // Dark translucent overlay
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "white",
      padding: vh(20),
      borderRadius: vw(8),
      width: "90%", // Adapt to smaller screens
      maxWidth: vw(500),
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
      position: "relative",
      zIndex: 10000, // Ensure it's above the overlay
      animation: "fadeIn 0.3s ease",
      fontFamily: "Karla, sans-serif",
      overflowX: "hidden",
    },
    closeBtn: {
      position: "absolute",
      top: vh(10),
      right: vw(15),
      fontSize: vh(32),
      fontWeight: "200",
      background: "none",
      border: "none",
      cursor: "pointer",
    },
    progressBarContainer: {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      margin: `${vh(20)} 0px ${vh(20)}  0px`,
      gap: vw(5),
    },
    stepCircle: {
      width: vh(11),
      height: vh(11),
      borderRadius: "50%",
      backgroundColor: "#ddd",
      transition: "background-color 0.3s ease",
    },
    stepCircleCompleted: {
      backgroundColor: "#192A3A",
    },
    nextStepCircle: {
      border: "1.5px solid #192A3A",
      width: vh(11),
      height: vh(11),
      backgroundColor: "transparent",
      transition: "background-color 0.3s ease",
    },

    stepDivider: {
      width: vw(220),
      height: vh(2),
      borderRadius: vw(5),
      backgroundColor: "#ccc",
      transition: "background-color 0.3s ease",
    },
    stepDividerCompleted: {
      backgroundColor: "#192A3A",
      transition: "background-color 0.3s ease",
    },

    titles: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "center",
      marginBottom: vh(20),
    },
    mainTitle: {
      fontSize: vh(24),
      fontWeight: "700",
      marginBottom: vh(5),
    },
    subTitle: {
      fontSize: vh(16),
      fontWeight: "300",
      color: "#666",
    },

    propertyDescriptionDetails: {},
    propertyName: {
      position: "relative",
    },
    inputContainer: {
      display: "flex",
      justifyContent: "space-between",
      gap: vw(10),
    },
    input: {
      width: "100%",
      padding: vh(10),
      marginBottom: vh(10),
      borderRadius: vw(5),
      border: "1px solid #ccc",
      fontSize: "16px",
    },
    select: {
      width: "100%",
      padding: vh(10),
      marginBottom: vh(10),
      borderRadius: vw(5),
      border: "1px solid #ccc",
      fontSize: vh(16),
    },
    imageInputContainer: {
      width: "100%",
      marginTop: vh(10),
      display: "flex",
      justifyContent: "space-between",
    },
    imageInputBox: {
      width: "60%",
      height: vh(200),
      borderRadius: vw(5),
      border: "1px dashed #ccc",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
    },
    imageInputLabel: {
      position: "absolute",
      textAlign: "center",
    },
    imageInput: {
      width: "100%",
      height: "100%",
      opacity: "0",
      cursor: "pointer",
    },
    imagePreviewContainer: {
      width: "60%",
      height: vh(200),
      borderRadius: vw(5),
      border: "1px solid #ccc",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      overflow: "hidden",
    },
    imagePreview: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    inputsOnTheRight: {
      width: "40%",
      height: vh(200),
      display: "flex",
      flexDirection: "column",
      gap: vw(10),
      alignItems: "end",
      justifyContent: "space-between",
    },
    imageInputBoxSmall: {
      width: "90%",
      height: "50%",
      borderRadius: vw(5),
      border: "1px dashed #ccc",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
    },
    imagePreviewContainerSmall: {
      width: "90%",
      height: vh(95),
    },
    imagePreviewSmall: {
      width: "100%",
      height: "100%",
      borderRadius: vw(5),
      objectFit: "cover",
    },
    buttonsContainer: {
      marginTop: currentStep === 3 ? vw(80) : vw(40),
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
    },
    cancelButton: {
      width: "50%",
      padding: vh(10),
      color: "white",
      borderRadius: vw(5),
      backgroundColor: "#B39359",
      border: "none",
      cursor: "pointer",
      marginRight: vw(10),
      transition: "background-color 0.3s ease",
    },
    cancelButtonHover: {
      backgroundColor: "#192A3A",
    },
    backButton: {
      width: "50%",
      padding: vw(10),
      color: "white",
      borderRadius: vw(5),
      backgroundColor: "#192A3A",
      border: "none",
      cursor: "pointer",
      marginRight: vw(10),
      transition: "background-color 0.3s ease",
    },
    backButtonHover: {
      backgroundColor: "#B39359",
    },
    nextButton: {
      width: "50%",
      padding: vh(10),
      backgroundColor: "#192A3A",
      color: "white",
      borderRadius: vw(5),
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    nextButtonHover: {
      backgroundColor: "#B39359",
    },
    skipButton: {
      width: "100%",
      padding: vh(10),
      backgroundColor: "#377771",
      color: "white",
      borderRadius: vw(5),
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },

    stepsSlider: {
      display: "flex",
      gap: vw(40),
      position: "relative",
      width: vw(460),
      height: currentStep === 3 ? vh(520) : vh(460),
      transform: `translateX(${vw(translationValue)})`,
      transition: "all 1s ease",
    },
    individualStepContainer: {
      minWidth: vw(460),
      // position: "absolute",
    },
  };

  //method to send data
  const createProperty = () => {
    const newWaterChargeType =
      selectedWaterChargeType === "No charge"
        ? "no-charge"
        : selectedWaterChargeType === "Fixed amount"
        ? "flat-rate"
        : "unit";

    const newLateFeeChargeType =
      selectedLateFeeChargeType === "No charge"
        ? "no-charge"
        : selectedLateFeeChargeType === "Fixed amount"
        ? "flat-rate"
        : "percentage";

    const newManagementFeeChargeType =
      selectedManagementFeeChargeType === "No charge"
        ? "no-charge"
        : selectedManagementFeeChargeType === "Fixed amount"
        ? "flat-rate"
        : "percentage";

    const newServiceChargeType =
      selectedServiceFeeChargeType === "No charge"
        ? "no-charge"
        : selectedServiceFeeChargeType === "Fixed amount"
        ? "flat-rate"
        : "percentage";

    const propertyDetails = {
      name: propertyName,
      location: propertyLocation,
      service_charge: serviceFeeCharge,
      service_charge_type: newServiceChargeType,
      water_charge: waterCharge,
      water_charge_type: newWaterChargeType,
      garbage_charge: garbageCharge,
      late_fee: lateFeeCharge,
      late_fee_type: newLateFeeChargeType,
      late_due_date: selectedRentDueDate,
      mgmt_fee: managementFeeCharge,
      mgmt_fee_type: newManagementFeeChargeType,
      images: [imageFile1, imageFile2, imageFile3],
      // bankName,
      // bankAccountNumber,
    };

    if (selectedMpesaPaymentMethod === "Mpesa PayBill") {
      propertyDetails.paybillAccountNumber = paybillNumber;
      propertyDetails.businessNumber = mpesaAccountNumber;
    } else {
      propertyDetails.tillNumber = tillNumber;
    }

    // Create payload for API request
    const payload = { propertyDetails };

    // Send data to the backend
    customToasts
      .promise(
        dispatch(addProperty(payload))
         .unwrap(),
        {
          pending: "Creating property...",
          success: "Property created successfully",
          error: "Failed to create property",
        }
      )
      .then(() => {
        dispatch(getAllProperties());

        // Advance tour if in tour mode and on Properties step
        if (isInTourMode() && getCurrentTourStep() === 1) {
          advanceTour();
        }

        closeModal();
      })
      .finally(() => {
        setIsNextButtonLoading(false);
      });
  };

  return (
    <div style={styles.overlay} onClick={closeModal}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.progressBarContainer}>
          <div
            style={{ ...styles.stepCircle, ...styles.stepCircleCompleted }}
          ></div>

          <div
            style={{ ...styles.stepDivider, ...styles.stepDividerCompleted }}
          ></div>

          <div
            style={{
              ...styles.stepCircle,
              ...(isStep1Completed
                ? styles.stepCircleCompleted
                : styles.nextStepCircle),
            }}
          ></div>

          <div
            style={{
              ...styles.stepDivider,
              ...(isStep1Completed ? styles.stepDividerCompleted : {}),
            }}
          ></div>

          {/* <div
            style={{
              ...styles.stepCircle,
              ...(isStep2Completed
                ? styles.stepCircleCompleted
                : styles.nextStepCircle),
            }}
          ></div>

          <div
            style={{
              ...styles.stepDivider,
              ...(isStep2Completed ? styles.stepDividerCompleted : {}),
            }}
          ></div> */}

          <div
            style={{
              ...styles.stepCircle,
              ...(isStep3Completed
                ? styles.stepCircleCompleted
                : styles.nextStepCircle),
            }}
          ></div>
        </div>
        <div style={styles.stepsSlider}>
          <div style={styles.individualStepContainer}>
            <div style={styles.titles}>
              <div style={styles.mainTitle}>Create Property</div>
              <div style={styles.subTitle}>
                Enter Details for creating the property
              </div>
            </div>
            <div style={styles.propertyDescriptionDetails}>
              <div style={styles.propertyName}>
                <label>Property name</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. Candle Light Apartments"
                  value={propertyName}
                  onChange={(e) => setPropertyName(e.target.value)}
                />
                <label>Property Location</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. Nairobi"
                  value={propertyLocation}
                  onChange={(e) => setPropertyLocation(e.target.value)}
                />
                <label>Property Images</label>
                <div style={styles.imageInputContainer}>
                  {!imagePreview1 ? (
                    <div style={styles.imageInputBox}>
                      <label style={styles.imageInputLabel}>
                        Property Outlook 1
                      </label>
                      <input
                        id="imageInput1"
                        style={styles.imageInput}
                        type="file"
                        placeholder="Upload Image"
                        onChange={handleImageChange1}
                      />
                    </div>
                  ) : (
                    <div style={styles.imagePreviewContainer}>
                      <img
                        src={imagePreview1}
                        alt="Image Preview 1"
                        style={styles.imagePreview}
                      />
                    </div>
                  )}
                  <div style={styles.inputsOnTheRight}>
                    {!imagePreview2 ? (
                      <div style={styles.imageInputBoxSmall}>
                        <label style={styles.imageInputLabel}>
                          Room Image 1
                        </label>
                        <input
                          id="imageInput2"
                          style={styles.imageInput}
                          type="file"
                          placeholder="Upload Image"
                          onChange={handleImageChange2}
                        />
                      </div>
                    ) : (
                      <div style={styles.imagePreviewContainerSmall}>
                        <img
                          src={imagePreview2}
                          alt="Image Preview 2"
                          style={styles.imagePreviewSmall}
                        />
                      </div>
                    )}
                    {!imagePreview3 ? (
                      <div style={styles.imageInputBoxSmall}>
                        <label style={styles.imageInputLabel}>
                          Room Image 2
                        </label>
                        <input
                          id="imageInput3"
                          style={styles.imageInput}
                          type="file"
                          placeholder="Upload Image"
                          onChange={handleImageChange3}
                        />
                      </div>
                    ) : (
                      <div style={styles.imagePreviewContainerSmall}>
                        <img
                          src={imagePreview3}
                          alt="Image Preview 3"
                          style={styles.imagePreviewSmall}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div style={styles.individualStepContainer}>
            <div style={styles.titles}>
              <div style={styles.mainTitle}>Assign Roles (Optional)</div>
              <div style={styles.subTitle}>
                Enter Details for assigning roles and roletakers in the property
              </div>
            </div>
            <div style={styles.roleTakersDescriptionDetails}>
              <div>
                <label>Role Type</label>
                <DropdownSelect
                  choices={choices}
                  defaultChoice={selectedRole}
                  onSelect={(choice) => setSelectedRole(choice)}
                />
              </div>
              <div>
                <label>Role Taker name</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. John Doe"
                  value={roleTakersName}
                  onChange={(e) => setRoleTakersName(e.target.value)}
                />
              </div>
              <div>
                <label>Role Taker email</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. example@gmail.com"
                  value={roleTakerEmail}
                  onChange={(e) => setRoleTakerEmail(e.target.value)}
                />
              </div>
              <div>
                <label>Role Taker Phone Number</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. +254 7234 578"
                  value={roleTakerPhoneNumber}
                  onChange={(e) => setRoleTakerPhoneNumber(e.target.value)}
                />
              </div>
            </div>
          </div> */}

          <div style={styles.individualStepContainer}>
            <div style={styles.titles}>
              <div style={styles.mainTitle}>Apartment Charges</div>
              <div style={styles.subTitle}>
                Set statuatory charges for the property for all tenants
              </div>
            </div>
            <div style={styles.water}>
              <label>Water charge Type</label>
              <div style={styles.inputContainer}>
                <DropdownSelect
                  choices={waterChargeTypeChoices}
                  defaultChoice={selectedWaterChargeType}
                  onSelect={(choice) => setSelectedWaterChargeType(choice)}
                />
                {selectedWaterChargeType === "No charge" && (
                  <>
                    <input
                      style={styles.input}
                      type="text"
                      placeholder="0ksh"
                      disabled={true}
                    />
                  </>
                )}
                {selectedWaterChargeType === "Fixed amount" && (
                  <>
                    <input
                      style={styles.input}
                      type="text"
                      placeholder="Water charge e.g. 2000"
                      value={waterCharge}
                      onChange={(e) => setWaterCharge(e.target.value)}
                    />
                  </>
                )}
                {selectedWaterChargeType === "Read from meter" && (
                  <>
                    <input
                      style={styles.input}
                      type="text"
                      placeholder="Unit Cost e.g. ksh 250"
                      value={waterCharge}
                      onChange={(e) => setWaterCharge(e.target.value)}
                    />
                  </>
                )}
              </div>
            </div>
            <div>
              <label>Rent Due Date</label>
              <DropdownSelect
                choices={rentDueDateChoices}
                defaultChoice={selectedRentDueDate}
                onSelect={(choice) => setSelectedRentDueDate(choice)}
              />
            </div>
            <div style={styles.lateFee}>
              <label>Late fee charge type</label>
              <div style={styles.inputContainer}>
                <DropdownSelect
                  choices={lateFeeChargeTypeChoices}
                  defaultChoice={selectedLateFeeChargeType}
                  onSelect={(choice) => setSelectedLateFeeChargeType(choice)}
                />
                {selectedLateFeeChargeType === "No charge" && (
                  <>
                    <input
                      style={styles.input}
                      type="text"
                      placeholder="0ksh"
                      disabled={true}
                    />
                  </>
                )}
                {selectedLateFeeChargeType === "Fixed amount" && (
                  <>
                    <input
                      style={styles.input}
                      type="number"
                      placeholder="e.g. ksh 500"
                      value={lateFeeCharge}
                      onChange={(e) => setLateFeeCharge(e.target.value)}
                    />
                  </>
                )}
                {selectedLateFeeChargeType === "% of Rent" && (
                  <>
                    <input
                      style={styles.input}
                      type="number"
                      placeholder="0"
                      value={lateFeeCharge}
                      onChange={(e) => setLateFeeCharge(e.target.value)}
                    />
                  </>
                )}
              </div>
            </div>

            <div style={styles.garbageCharge}>
              <label>Garbage charge</label>
              <div style={styles.inputContainer}>
                <input
                  style={styles.input}
                  type="number"
                  placeholder="e.g. 0 ksh"
                  value={garbageCharge}
                  onChange={(e) => setGarbageCharge(e.target.value)}
                />
              </div>
            </div>
            <div style={styles.serviceFee}>
              <label>Service fee charge type</label>
              <div style={styles.inputContainer}>
                <DropdownSelect
                  choices={lateFeeChargeTypeChoices}
                  defaultChoice={selectedServiceFeeChargeType}
                  onSelect={(choice) => setSelectedServiceFeeChargeType(choice)}
                />
                {selectedServiceFeeChargeType === "No charge" && (
                  <>
                    <input
                      style={styles.input}
                      type="number"
                      placeholder="0ksh"
                      disabled={true}
                    />
                  </>
                )}
                {selectedServiceFeeChargeType === "Fixed amount" && (
                  <>
                    <input
                      style={styles.input}
                      type="number"
                      placeholder="e.g. ksh 500"
                      value={serviceFeeCharge}
                      onChange={(e) => setServiceFeeCharge(e.target.value)}
                    />
                  </>
                )}
                {selectedServiceFeeChargeType === "% of Rent" && (
                  <>
                    <input
                      style={styles.input}
                      type="number"
                      placeholder="e.g. 2%"
                      value={serviceFeeCharge}
                      onChange={(e) => setServiceFeeCharge(e.target.value)}
                    />
                  </>
                )}
              </div>
            </div>
            <div style={styles.managementFee}>
              <label>Management fee charge type</label>
              <div style={styles.inputContainer}>
                <DropdownSelect
                  choices={lateFeeChargeTypeChoices}
                  defaultChoice={selectedManagementFeeChargeType}
                  onSelect={(choice) =>
                    setSelectedManagementFeeChargeType(choice)
                  }
                />
                {selectedManagementFeeChargeType === "No charge" && (
                  <>
                    <input
                      style={styles.input}
                      type="number"
                      placeholder="0ksh"
                      disabled={true}
                    />
                  </>
                )}
                {selectedManagementFeeChargeType === "Fixed amount" && (
                  <>
                    <input
                      style={styles.input}
                      type="text"
                      placeholder="e.g. ksh 500"
                      value={managementFeeCharge}
                      onChange={(e) => setManagementFeeCharge(e.target.value)}
                    />
                  </>
                )}
                {selectedManagementFeeChargeType === "% of Rent" && (
                  <>
                    <input
                      style={styles.input}
                      type="text"
                      placeholder="e.g. 2%"
                      value={managementFeeCharge}
                      onChange={(e) => setManagementFeeCharge(e.target.value)}
                    />
                  </>
                )}
              </div>
            </div>
          </div>

          <div style={styles.individualStepContainer}>
            <div style={styles.titles}>
              <div style={styles.mainTitle}>Property Payment Details</div>
              <div style={styles.subTitle}>
                Enter Details for receiving payments from tenants
              </div>
            </div>
            <div style={styles.paymentDescriptionDetails}>
              <div>
                <label>Mpesa payment method</label>
                <DropdownSelect
                  choices={mpesaPaymentMethodChoices}
                  defaultChoice={selectedMpesaPaymentMethod}
                  onSelect={(choice) => setSelectedMpesaPaymentMethod(choice)}
                />
              </div>
              {selectedMpesaPaymentMethod === "Mpesa PayBill" && (
                <div>
                  <label>Paybill Number</label>
                  <input
                    style={styles.input}
                    type="number"
                    placeholder="e.g. 123456"
                    value={paybillNumber}
                    onChange={(e) => setPaybillNumber(e.target.value)}
                  />
                </div>
              )}
              {selectedMpesaPaymentMethod === "Mpesa PayBill" && (
                <div>
                  <label>Account Number</label>
                  <input
                    style={styles.input}
                    type="number"
                    placeholder="e.g. 123456"
                    value={mpesaAccountNumber}
                    onChange={(e) => setMpesaAccountNumber(e.target.value)}
                  />
                </div>
              )}
              {selectedMpesaPaymentMethod === "Mpesa Till Number" && (
                <div>
                  <label>Till Number</label>
                  <input
                    style={styles.input}
                    type="number"
                    placeholder="e.g. 123456"
                    value={tillNumber}
                    onChange={(e) => setTillNumber(e.target.value)}
                  />
                </div>
              )}

              {/* <div style={{ marginTop: vh(20) }}>
                <label>Bank Name</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. KCB Bank"
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                />
              </div>
              <div>
                <label>Bank Account Number</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. 123456"
                  value={bankAccountNumber}
                  onChange={(e) => setBankAccountNumber(e.target.value)}
                />
              </div> */}
            </div>
          </div>
        </div>

        <div style={styles.buttonsContainer}>
          {showBackButton ? (
            <>
              <button
                style={{
                  ...styles.backButton,
                  ...(isBackButtonHovered ? styles.backButtonHover : {}),
                }}
                onClick={setPreviousStep}
                onMouseEnter={() => setIsBackButtonHovered(true)}
                onMouseLeave={() => setIsBackButtonHovered(false)}
              >
                Back
              </button>
            </>
          ) : (
            <button
              style={{
                ...styles.cancelButton,
                ...(isCancelButtonHovered ? styles.cancelButtonHover : {}),
              }}
              onClick={closeModal}
              onMouseEnter={() => setIsCancelButtonHovered(true)}
              onMouseLeave={() => setIsCancelButtonHovered(false)}
            >
              Cancel
            </button>
          )}

          {/* {showSkipButton ? (
            <button
              style={styles.skipButton}
              onClick={() => {
                setIsSkipButtonClicked(true);
                setNextStep();
              }}
            >
              Skip
            </button>
          ) : ( */}
          <button
            style={{
              ...styles.nextButton,
              ...(isNextButtonHovered ? styles.nextButtonHover : {}),
              ...(isNextButtonLoading ? { opacity: 0.6, cursor: "not-allowed" } : {}),
            }}
            onMouseEnter={() => setIsNextButtonHovered(true)}
            onMouseLeave={() => setIsNextButtonHovered(false)}
            onClick={() => {
              if (!isNextButtonLoading) setNextStep();
            }}
            disabled={isNextButtonLoading}
          >
            {isNextButtonLoading ? "Processing..." : "Next"}
          </button>
          {/* )} */}
        </div>
      </div>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Zoom}
      />
    </div>
  );
};

export default CreatePropertyModal;
